import DataTable from '@/components/DataTable';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import Base64Viewer from '@/components/Base64Viewer';
import { matchesApprovalRole } from '@/utils/approvalRoles';
import {
  Tabs,
  Modal,
  Input,
  Timeline,
  Form,
  Drawer,
  Pagination,
  Tag,
  Collapse,
  Descriptions,
  Divider,
  Select as AntSelect,
  Row,
  Col,
  InputNumber,
  Button,
  Card,
  Tooltip,
  Typography as AntTypography,
  Checkbox as AntCheckbox,
  QRCode as AntQRCode,
  Empty,
} from 'antd';
// Material-UI components removed - now using Ant Design
import {
  CloseOutlined,
  EyeOutlined,
  PlusOutlined,
  CheckSquareOutlined,
  SearchOutlined,
  PrinterOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Scheduling from './Scheduling';
import { accessControlUtils } from '@/components/AccessControlUtils';
import {
  bp_get_batch_report_view,
  get_batch_details_by_process_id,
  get_bill_of_materials,
  bp_update_starttime_for_batch_number,
  get_material_lots,
  get_seperate_qr_details,
  reprint_seperate_qr,
} from '@/utils/api';

import { toast } from 'react-toastify';
import useTableConfig from '@/hooks/useTableConfig';
import TableColumnConfig from '@/components/TableColumnConfig';
import OperationsSkeleton from '../RecipeOperationsDetails';
import DAGFlowCopy from '@/pages/dashboard/ArchiMateFlow';
import { DatePicker } from 'antd';
import CompletedKitting from './CompletedKitting';
import Graph from '../Configurations/Graph';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setChangeTestProd } from '@/store/reducers/testProdSelect';
import { defaultColors } from '@/themes/antd-theme';
import { useTheme } from '@/App';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Icons from '@/components/third-party/Icons';
import { useMbmrAlias, useIngredientsAlias } from '@/hooks/useAppSetting';
import {
  formatDateTime,
  formatDateTimeSeconds,
  formatDate as formatDisplayDate,
  sortTime,
} from '@/utils/datetime';
import BatchStatusCell from '@/components/batch/BatchStatusCell';
import BatchListTab from './bmr-details/BatchListTab';
import {
  BatchListFilters,
  BatchStateTiles,
  CompletedStatusFilters,
  TerminateBatchModal,
  useBmrdVars,
} from './bmr-details/BmrDetailsParts';
import { ongoingColumns, rejectedColumns } from './bmr-details/columns';
import BatchReportModal from './bmr-details/BatchReportModal';
import MaterialBalanceModal from './bmr-details/MaterialBalanceModal';
import IssueApprovalTab from './bmr-details/IssueApprovalTab';
import {
  completedParams,
  fetchCompleted,
  fetchIssueApproval,
  fetchOngoing,
  fetchRejected,
  fetchSummary,
  listParams,
} from './bmr-details/bmrDetailsApi';
import ApprovalSignModal, { postAct, actErrorMessage, showGateReasons } from './ApprovalSignModal';
import MBMRDetailsModal from '@/components/MBMRDetailsModal';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/components/PageHeader';
import PageModal from '@/components/PageModal';
/** A BOM quantity as people read it: up to 4 decimals, no trailing zeros, a count as a whole. */
const fmtQty = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  return String(+n.toFixed(4));
};

// Icon component aliases for compatibility with existing code

const CheckBoxIcon = CheckSquareOutlined;
const project_type = 'pharma';
const { Text, Title } = AntTypography;

// Component aliases for MUI compatibility
const IconButton = Button;
const Typography = AntTypography;
const Grid = Row;
const Box = ({ children, style, ...props }) => (
  <div style={style} {...props}>
    {children}
  </div>
);
// Checkbox alias with MUI-like props support
const Checkbox = ({ checked, icon, checkedIcon, size, ...props }) => (
  <AntCheckbox checked={checked} {...props}>
    {checked ? checkedIcon : icon}
  </AntCheckbox>
);
// FormControlLabel alias for MUI compatibility
const FormControlLabel = ({ control, label, ...props }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }} {...props}>
    {control}
    {label && <span style={{ marginLeft: 4 }}>{label}</span>}
  </span>
);
// ButtonGroup alias for MUI compatibility

// Stable slugs for the ?tab= deep link so callers (the sidebar menu, mails, docs)
// never have to hard-code the numeric antd tab keys.
const TAB_SLUGS = {
  'issue-approval': '8',
  ongoing: '9',
  completed: '3',
  rejected: 'rejected',
  // the KPI registry's tile links (services/dashboards/kpis): every open state lists on Ongoing
  running: '9',
  hold: '9',
  scheduled: '9',
};

function ScheduledBatches() {
  const { isDark } = useTheme();
  const { t } = useTranslation();
  // Dark mode colors
  const cardBgColor = isDark ? defaultColors.palette.gray[800] : '#ffffff';
  const textColor = isDark ? '#ffffff' : '#1f2937';
  const secondaryTextColor = isDark ? defaultColors.palette.gray[400] : '#6b7280';
  const borderColor = isDark ? defaultColors.palette.gray[600] : '#e5e7eb';
  const tabBgColor = isDark ? defaultColors.palette.gray[700] : '#f9f9f9';
  const sectionBgColor = isDark ? defaultColors.palette.gray[800] : '#ffffff';

  const [user_access_data, set_user_access_data] = useState([]);
  const location = useLocation();
  const [appSetting, setAppSetting] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('app_setting')) || [];
    } catch {
      return [];
    }
  });
  // Enablement is derived from the setting's value (the status column is retired).
  // Defaults to visible (true) when the setting is absent.
  const mbmrAlias = useMbmrAlias();
  const ingredientsAlias = useIngredientsAlias();
  const [minMaxBatchSize, setMinMaxBatchSize] = useState();
  const [show_add_schedule, set_show_add_schedule] = useState(false);
  const [mbmrModal, setMbmrModal] = useState({ open: false, recipeId: null, title: '' });
  const [batchSize, setBatchSize] = useState('');
  const [searchvalue, setSearchvalue] = useState('');
  const [refresh, set_refresh] = useState(false);
  const [kittingColumnMenu, setKittingColumnMenu] = useState(null);
  const [showGraph, setShowGraph] = useState(false);
  const [is_schedule_lot, set_is_schedule_lot] = useState(false);
  const [selectedBatchNumber, set_selectedBatchNumber] = useState('');
  const [selectedBatchForGraph, setSelectedBatchForGraph] = useState(null);
  const { Panel } = Collapse;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const deepLinkHandled = useRef(null);
  const [reportData, setReportData] = useState([]);
  const [processOperations, set_processOperations] = useState([]);
  const [tab_value, set_tab_value] = useState('9');
  const [showSummary, set_showSummary] = useState(false);
  const [showSummaryIndex, set_showSummaryIndex] = useState();
  const [assignStatus, setAssignStatus] = useState(false);
  const [selected_recipe, set_selected_recipe] = useState('');
  const [reportView, setReportView] = useState(false);
  // 2026-11-01 (owner) · Completed → View Report: the batch whose run the modal shows (BatchReportModal).
  const [reportBatch, setReportBatch] = useState(null);
  const [balanceBatch, setBalanceBatch] = useState(null);
  const [workflowReportView, setworkflowReportView] = useState(false);
  const [selectedProcessId, set_selectedProcessId] = useState('');
  const [selectedProcessName, set_selectedProcessName] = useState('');
  const dispatch = useDispatch();
  const selectedButton = useSelector((state) => state.testProdView);
  // recipe_type reflects the header Test/Production toggle, sent as the capitalized
  // string 'True' (Production) / 'False' (Test) so the backend parses it uniformly.
  const recipeTypeFlag = selectedButton === 'production';
  const [bomList, set_bomList] = useState([]);
  const [view_bom_data, set_view_bom_data] = useState(null);
  // Lot picker state for BOM material lot allocation
  const [lotPicker, setLotPicker] = useState({ open: false, material: null, required: 0 });
  const [availableLots, setAvailableLots] = useState([]);
  // Map: material_id -> [{ lot_id, batch_number, lot_number, consumed_qty, available_qty, expiry_date }]
  const [selectedLots, setSelectedLots] = useState({});
  // Per-row in-modal selection state
  const [pickerSelection, setPickerSelection] = useState({});
  const [row_expand, set_row_expand] = useState([]);
  const [summaryData, setSummaryData] = useState();
  //Pagination
  const [page_number, set_page_number] = useState(1);
  const [isVisible, set_isVisible] = useState(false);
  const [modified_details, set_modified_details] = useState([]);
  const schedulingAccess = accessControlUtils('Batches');
  const isESign = accessControlUtils('ESign')?.create_access || false;
  const selectedModule = useSelector((state) => state.moduleView);
  // "Issue Batch" = creating a batch from an approved MBMR/MBPR. Never "release" —
  // that word is reserved for the QA disposition of a finished batch (/batch-approval).
  const issueBatchLabel = selectedModule === 'prod' ? 'Issue Batch' : 'Issue Packaging Batch';
  const recordWord = selectedModule === 'pack' ? 'BPR' : 'BMR';
  const mbmrWord = selectedModule === 'pack' ? 'MBPR' : mbmrAlias;
  const bmrdVars = useBmrdVars();
  const [isBomVisible, setIsBomVisible] = useState(false);
  const [batch_type, set_batch_type] = useState('master');
  const [master_batch, set_master_batch_number] = useState('master'); // for auto select master batch drop down in release lot page
  const [terminateRecord, setTerminateRecord] = useState(null);
  const [dag_batch, set_dag_batch] = useState();
  const [productName, setProductName] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [rowRecord, setRowRecord] = useState({});
  const [selectedColumnList, set_selectedColumnList] = useState({
    columns: [{ title: 'Placeholder', dataIndex: 'placeholder', key: 'placeholder' }],
    data: [],
  });
  const [showESignatureModal, setShowESignatureModal] = useState(false);
  const [pendingApprovalBatch, setPendingApprovalBatch] = useState(null);
  const [releaseSignAction, setReleaseSignAction] = useState('approve');   // F5: approve / reject are one signed call
  const [releaseSigning, setReleaseSigning] = useState(false);
  const [separateQrData, setSeparateQrData] = useState([]);
  const [separateQrTotal, setSeparateQrTotal] = useState(0);
  const [separateQrMaxPage, setSeparateQrMaxPage] = useState(1);
  const [separateQrPage, setSeparateQrPage] = useState(1);
  const [separateQrSearch, setSeparateQrSearch] = useState('');
  const [separateQrLoading, setSeparateQrLoading] = useState(false);
  const [reprintLoading, setReprintLoading] = useState(null);
  const [previewRecord, setPreviewRecord] = useState(null);
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  // EXV-027: the list filters every tab shares (MBMR, schedule-date range, search). A ?batch= link (a ticket's
  // deviation, the retired /bmr-tracking) opens the Ongoing list searched on that batch.
  const [listFilters, setListFilters] = useState(() => ({
    recipeId: null,
    from: null,
    to: null,
    search: (searchParams.get('batch') || '').trim(),
  }));
  // the Completed list's own filters (status, released by, released on) and the options the server says are present
  const [completedFilters, setCompletedFilters] = useState({ status: null, releasedBy: null, releasedFrom: null, releasedTo: null });
  const [completedOptions, setCompletedOptions] = useState(null);
  // bumped when the filters change or an act changes a list — every list re-reads page 1
  const [listReload, setListReload] = useState(0);
  const reloadLists = () => setListReload((n) => n + 1);
  const [summaryTick, setSummaryTick] = useState(0);
  const [summaryError, setSummaryError] = useState(null);
  const canTerminate = !!accessControlUtils('Batch Lifecycle')?.create_access; // EXV-031: the act's own module
  // W1-9: the issue-approval act (POST release_approval) is "BMR Approval" create on the server
  const canDecideIssue = !!accessControlUtils('Approvals')?.create_access;
  const canIssue =
    !!accessControlUtils('Issue Batch')?.create_access || !!schedulingAccess?.create_access;

  const reset_flow = () => {
    set_dag_batch(null);
    setSelectedRowKeys([]);
  };


  // Use table config with safe defaults
  const { visibleColumns, columnConfigMenu, filteredData } = useTableConfig({
    tableKey: 'prodRecipeApprovalTable',
    columns:
      selectedColumnList?.columns?.length > 0
        ? selectedColumnList.columns
        : [{ title: 'Placeholder', dataIndex: 'placeholder', key: 'placeholder' }],
    data: selectedColumnList?.data || [],
    searchValue: searchvalue,
  });
  const ingredientStringConcat = (data, header) => {
    return data?.map((ingredient, index) => {
      let ingredientString = `${ingredient?.material_name?.split('(')[0]} `;
      if (header === 'operation') {
        // Conditionally include the parameter with its min and max values if they exist
        ingredientString += '';
        // ingredient.parameter_name && `(${ingredient.parameter_name}), `;"
      } else {
        ingredientString += `: ${ingredient.quantity}(${ingredient?.material_unit})`;
        if (ingredient.parameter_name !== '') {
          ingredientString += `${ingredient.parameter_name}`;
        } else {
          ingredientString += `-`;
        }
      }
      ingredientString += index === data?.length - 1 ? '' : ',';
      return ingredientString;
    });
  };

  const start_batch = (batch_id, bmrBatch) => {
    bp_update_starttime_for_batch_number(
      {
        batch_id: batch_id,
        bmr_batch: bmrBatch,
      },
      (res) => {
        if (res.status === 'failed') {
          toast.warning(res.message);
        } else {
          toast.success(res.message);
          set_current_expand('');
          get_all_batchDetails();
        }
      }
    );
  };

  const evaluateFormula = (formula, standard, actual, batchSize) => {
    const context = {
      value1: standard,
      value2: actual,
      value3: batchSize,
    };
    try {
      // Create a safe function to evaluate the formula
      const formulaFunction = new Function(...Object.keys(context), `return ${formula};`);

      // Execute the function with dynamic values
      const evaluatedResult = formulaFunction(...Object.values(context));

      return evaluatedResult;
    } catch (error) {
      console.error('Error evaluating formula:', error);
      return 'Error in formula evaluation';
    }
  };

  const buttonStyles = (isSelected) => ({
    width: '100px',
    backgroundColor: isSelected ? '#1976d2' : 'inherit', // Use primary.main color or change it to match your theme
    color: isSelected ? '#ffffff' : 'inherit', // Use primary.contrastText color or change it to match your theme
    border: '1px solid #1976d2', // Optional: to have a consistent border color
    '&:hover': {
      backgroundColor: isSelected ? '#115293' : 'inherit', // Use primary.dark color or change it to match your theme
    },
  });

  const get_batch_details_by_process = async (process_id, batch_number) => {
    try {
      await get_batch_details_by_process_id(res_get_details, {
        process_id: process_id,
        batch_number: batch_number,
      });
    } catch (error) {
      console.log(error);
    }
  };





  const get_all_bom_data = async (bom_data) => {
    try {
      await get_bill_of_materials(
        { recipe_id: bom_data?.recipe_id, batch_size: bom_data?.batch_size,
          ...(bom_data?.batch_number ? { batch_number: bom_data.batch_number } : {}) },
        sucess_bom_get
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const sucess_bom_get = (res) => {
    if (res?.data?.data && res?.data?.data?.length > 0) {
      set_bomList(res?.data?.data);
    } else {
      set_bomList([]);
    }
  };

  // ===== BOM Lot Picker helpers =====
  const computeRequiredQty = (record) => {
    // 2026-10-15 · the server's calculated quantity for this batch size, where it gives one
    if (record?.batch_quantity != null) return Number(record.batch_quantity) || 0;
    if (!batchSize || batchSize === '0') return 0;
    const calculatedValue = appSetting?.find(
      (app) => app?.module === 'Material Cost Calculation'
    )?.value;
    if (calculatedValue) {
      const op = evaluateFormula(
        calculatedValue,
        record?.quantity,
        minMaxBatchSize?.actual,
        batchSize
      );
      if (Number.isFinite(Number(op))) return Number(Number(op).toFixed(2)) || 0;
    }
    return parseFloat(record?.quantity || 0) * parseFloat(batchSize || 0);
  };

  const openLotPicker = (record) => {
    const required = computeRequiredQty(record);
    setLotPicker({ open: true, material: record, required });
    // Initialize picker selection from any existing selection for this material
    const existing = selectedLots[record.material_id] || [];
    const sel = {};
    existing.forEach((l) => {
      sel[l.lot_id] = l.consumed_qty;
    });
    setPickerSelection(sel);
    // Fetch available lots for this material
    get_material_lots({ material_id: record.material_id, module_type: selectedModule }, (res) => {
      const lots = res?.data?.data || [];
      // Sort FEFO (earliest expiry first); skip expired/zero
      const today = new Date();
      const usable = lots
        .filter((l) => (l.quantity_available || 0) > 0)
        .filter((l) => !l.expiry_date || new Date(l.expiry_date) >= today)
        .sort(
          (a, b) =>
            new Date(a.expiry_date || '9999-12-31') - new Date(b.expiry_date || '9999-12-31')
        );
      setAvailableLots(usable);
    });
  };

  const closeLotPicker = () => {
    setLotPicker({ open: false, material: null, required: 0 });
    setAvailableLots([]);
    setPickerSelection({});
  };

  const togglePickerLot = (lot, checked) => {
    setPickerSelection((prev) => {
      const next = { ...prev };
      if (checked) {
        next[lot.lot_id] = lot.quantity_available;
      } else {
        delete next[lot.lot_id];
      }
      return next;
    });
  };

  const updatePickerLotQty = (lot_id, qty) => {
    setPickerSelection((prev) => ({ ...prev, [lot_id]: qty }));
  };

  const pickerTotal = Object.values(pickerSelection).reduce((sum, q) => sum + (Number(q) || 0), 0);

  const confirmLotPicker = () => {
    const mat = lotPicker.material;
    if (!mat) return;
    const chosen = availableLots
      .filter((l) => pickerSelection[l.lot_id] !== undefined)
      .map((l) => ({
        lot_id: l.lot_id,
        batch_number: l.batch_number,
        lot_number: l.lot_number,
        consumed_qty: Number(pickerSelection[l.lot_id]) || 0,
        available_qty: l.quantity_available,
        expiry_date: l.expiry_date,
        // Parameter values come directly from the lot's API response — read-only.
        parameter_values: Array.isArray(l.quality_parameters)
          ? l.quality_parameters.map((p) => ({
              parameter_id: p.parameter_id,
              name: p.name,
              unit: p.unit,
              data_type: p.data_type,
              value: p.value ?? null,
            }))
          : [],
      }));
    setSelectedLots((prev) => ({ ...prev, [mat.material_id]: chosen }));
    closeLotPicker();
  };
  // to check all operations are scheduled or not


  // EXM-00 S2: terminate and cancel-issue are signed acts — the password travels with the act.


  const res_get_details = (res) => {
    if (res?.data?.status === 'success') {
      if (res?.data?.data && res?.data?.data?.length > 0) {
        set_processOperations(res?.data?.data[0]?.operations);
        const reqList = res?.data?.data[0]?.operations?.map((item, index) => {
          return {
            status: false,
            value: '',
            emp_status: '', // Update the key to the index converted to a string
          };
        });
        setScheduleTimeStatus(reqList);
      } else {
        setScheduleTimeStatus([]);
      }
    }
  };

  const formatDate = (date) => {
    const dateObject = new Date(date);
    const formattedDateTime = `${dateObject.getFullYear()}-${(dateObject.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${dateObject.getDate().toString().padStart(2, '0')} ${dateObject
      .getHours()
      .toString()
      .padStart(2, '0')}:${dateObject.getMinutes().toString().padStart(2, '0')}:${dateObject
      .getSeconds()
      .toString()
      .padStart(2, '0')}`;
    return formattedDateTime;
  };

  const ingredientStrings = (data, header) => {
    return data?.map((ingredient) => {
      let ingredientString = `${ingredient.ingredient_name} `;
      if (header === 'operation') {
        // Conditionally include the parameter with its min and max values if they exist
        ingredientString = `${ingredientString},`;
      } else {
        ingredientString += `${ingredient.ingredient_qty + ' '} ${ingredient.conditinal_para}, `;
        if (
          ingredient.parameter_name !== '' &&
          ingredient.min_value >= 0 &&
          ingredient.max_value > 0
        ) {
          ingredientString += ` (${ingredient.parameter_name} with min ${ingredient.min_value}${ingredient.parameter_name_unit} and max ${ingredient.max_value}${ingredient.parameter_name_unit})`;
        }
      }
      return ingredientString;
    });
  };

  //For collapse open at a time only one row
  const addKeysInFilterDataForCollapse = (filterData) => {
    const updatedFilterList = filterData?.map((item, index) => {
      return {
        ...item,
        key: index.toString(), // Update the key to the index converted to a string
      };
    });
    return updatedFilterList;
  };

  const [current_batch, set_current_batch] = useState('');
  const [current_expand, set_current_expand] = useState('');
  const [scheduleTimeStatus, setScheduleTimeStatus] = useState([]);
  const [bulk_assign_list, set_bulk_assign_list] = useState([]);


  const handleExpandRow = (expanded, record) => {
    if (expanded) {
      set_row_expand(record?.key);
    } else {
      set_row_expand('');
    }
  };


  const [dag_nodes, set_dag_nodes] = useState([]);
  const handleCancel = () => {
    set_isVisible(false);
    setIsBomVisible(false);
  };
  const processColumns = [
    {
      title: 'Process Name',
      dataIndex: 'process_name',
      key: 'Operation',
      align: 'center',
      sorter: (a, b) => a?.process_name?.localeCompare(b?.process_name), // ✅ sorting
    },
    {
      title: 'Area',
      dataIndex: 'area_section',
      render: (area) => (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            maxHeight: '80px', // limit height
            overflowY: 'auto', // scroll when too many lines
            gap: '8px',
          }}
        >
          {area &&
            Array.isArray(area) &&
            area?.length > 0 &&
            area?.map((area, index) => (
              <Tag key={index} color="green">
                {area}
              </Tag>
            ))}
        </div>
      ),
    },
    {
      title: 'Assigned Roles ',
      dataIndex: 'emp_roles',
      render: (roles) => (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            maxHeight: '80px', // limit height
            overflowY: 'auto', // scroll when too many lines
            gap: '8px',
          }}
        >
          {roles &&
            Array.isArray(roles) &&
            roles?.length > 0 &&
            roles?.map((roles, index) => (
              <Tag key={index} color="green">
                {roles}
              </Tag>
            ))}
        </div>
      ),
    },
  ];
  const expandedRowRenderCols = (record) => {
    const updateData = record?.operations?.map((item, index) => {
      return {
        ...item,
        key: index.toString(), // Update the key to the index converted to a string
      };
    });

    const modiedDataColums = [
      {
        title: 'Operation Number',
        dataIndex: 'operation_number',
        key: 'Operation',
        align: 'center',
      },
      {
        title: 'Operation',
        dataIndex: 'operation_type',
        key: 'operation_type',
        align: 'center',
        render: (data, record, index) => {
          const ingred = ingredientStringConcat(record.ingredients, 'operation');

          return (
            <div style={{ textAlign: 'left' }}>
              <p>
                <strong> Operation Type: </strong>
                {`${data}, `} <br />
                {record?.operation_name && (
                  <>
                    <strong> Operation : </strong>
                    <span>{`${record?.operation_name}, `}</span> <br />
                  </>
                )}
                {record?.instruction?.length > 0 && (
                  <>
                    <strong>Instructions:</strong>
                    <Tooltip title="View Instructions">
                      <IconButton
                        onClick={() => {
                          Modal.info({
                            title: 'Instructions',
                            content: (
                              <ul>
                                {record?.instruction?.map((instruction, index) => (
                                  <li key={index}>{instruction}</li>
                                ))}
                              </ul>
                            ),
                          });
                        }}
                        disabled={record?.instruction?.length === 0}
                      >
                        <EyeOutlined color="info" style={{ fontSize: '21px' }} />
                      </IconButton>
                    </Tooltip>
                    <br />
                  </>
                )}
                {record?.dependencie && (
                  <>
                    <strong> Depending on Operations: </strong>
                    <span>{`${record?.dependencie}`}</span>
                    <br />
                  </>
                )}
                {ingred && ingred?.length > 0 && (
                  <>
                    <strong> {ingredientsAlias}: </strong>
                    {ingred.join('\n')}
                  </>
                )}
              </p>
            </div>
          );
        },
      },
      {
        title: 'Equipment',
        dataIndex: 'machine_name',
        align: 'center',
        key: 'machine_name',
      },
      {
        title: 'Duration',
        dataIndex: 'max_duration',
        key: 'max_duration',
        align: 'center',
      },
      {
        title: 'Details / Remarks',
        dataIndex: 'products',
        key: 'process_products',
        width: '25%',
        align: 'center',
        render: (data, record, index) => {
          const ingred = ingredientStringConcat(record?.ingredients, '');
          let mul = 'X Batch Size';
          let perc = '% of Batch Size';
          return (
            <div style={{ textAlign: 'left' }}>
              {ingred?.length > 0 && (
                <>
                  <strong> {ingredientsAlias}: </strong>
                  {/* {ingred?.map((data, index) => (
                        <div key={index}>{data}</div>
                      ))} */}
                  <div className="mb-4">
                    {ingred?.map((data, index) => {
                      return (
                        <>
                          <div key={index}>
                            <strong>{`${index + 1}.  `}</strong>
                            {data?.split('#')?.length > 1
                              ? `${data?.split('#')[0]}-- [${data?.split('#')[1]}] `
                              : data?.replace('-', '')}
                            {/* {record?.ingredients[index]?.is_percentage
                              ? "" + perc
                              : record?.ingredients[index]?.unit + mul} */}
                          </div>
                        </>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          );
        },
      },
    ];
    return (
      <DataTable
        height={null}
        data={updateData}
        columns={modiedDataColums}
        pagination={false}
        showHeader={true}
        expandable={{
          expandedRowRender: expandedRowRenderData,
          onExpand: handleExpandRow,
          // onExpandedRowsChange: (expanded) => set_row_expand(expanded),
          expandedRowKeys: [row_expand],
          // expandedRowClassName: () => "col2",
        }}
      />
    );
  };

  const expandedRowRenderData = (record) => {
    return (
      <Collapse accordion>
        {record?.process_products?.length > 0 && (
          <>
            <Panel header="Product" key="1">
              <DataTable
                height={null}
                pagination={false}
                columns={[
                  {
                    title: 'Product Name',
                    dataIndex: 'product_name',
                    key: 'product_name',
                  },
                  {
                    title: 'Process Thero Quantity',
                    dataIndex: 'process_thero_quantity',
                    key: 'operation_number',
                    render: (data, record, index) => {
                      return <p>{`${data} (${record.product_name_unit})`}</p>;
                    },
                  },
                  {
                    title: 'Expected Min Value',
                    dataIndex: 'process_expec_min_value',
                    key: 'process_expec_min_value',
                    render: (data, record, index) => {
                      return <p>{`${data} (${record.product_name_unit})`}</p>;
                    },
                  },
                  {
                    title: 'Expected Max Value',
                    dataIndex: 'process_expec_max_value',
                    key: 'process_expec_max_value',
                    render: (data, record, index) => {
                      return <p>{`${data} (${record.product_name_unit})`}</p>;
                    },
                  },
                ]}
                data={record?.process_products || []}
                bordered
                style={{ width: '100%' }}
              />
            </Panel>
          </>
        )}

        {record?.process_parameters && record?.process_parameters?.length > 0 && (
          <>
            <Panel header="Process Parameters" key="2">
              <DataTable
                height={null}
                pagination={false}
                columns={[
                  {
                    title: 'Parameter',
                    dataIndex: 'parameter_name',
                    rowScope: 'row',
                  },
                  {
                    title: 'Readings Per Interval (HH:MM:SS)',
                    dataIndex: 'parameter_max_value',
                    key: 'parameter_max_value',
                    render: (data, record, index) => {
                      return <p>{`${data}`}</p>;
                    },
                  },
                  {
                    title: 'Quantity',
                    dataIndex: 'quantity',
                    key: 'qunatity',
                    align: 'center',
                    render: (data, record) => {
                      return <p>{`${data} (${record?.parameter_name_unit})`}</p>;
                    },
                  },
                  {
                    title: 'Readings',
                    dataIndex: 'reading',
                    key: 'min_value',
                    align: 'center',
                  },
                  {
                    title: 'Min',
                    dataIndex: 'min_value',
                    key: 'min_value',
                    align: 'center',
                    render: (data, record) => {
                      return <p>{data ? `${data} (${record?.parameter_name_unit})` : 'NA'}</p>;
                    },
                  },
                  {
                    title: 'Max',
                    dataIndex: 'max_value',
                    key: 'max_value',
                    align: 'center',
                    render: (data, record) => {
                      return <p>{data ? `${data} (${record?.parameter_name_unit})` : 'NA'}</p>;
                    },
                  },
                ]}
                data={record?.process_parameters || []}
                bordered
                style={{ width: '100%' }}
              />
            </Panel>
          </>
        )}
        {record?.sampling && record?.sampling?.length > 0 && (
          <Panel header="Sampling" key="3">
            <DataTable
              height={null}
              pagination={false}
              columns={[
                {
                  title: 'Output',
                  align: 'center',
                  dataIndex: 'material_inventory_name',
                  key: 'material_inventory_name',
                },
                {
                  title: 'Quantity',
                  align: 'center',
                  dataIndex: 'quantity',
                  key: 'quantity',
                  render: (data, record, index) => {
                    return <p>{`${data} (${record.material_inventory_unit})`}</p>;
                  },
                },
                {
                  title: 'Testing Type',
                  align: 'center',
                  dataIndex: 'testing_type_name',
                  key: 'testing_type_name',
                },
                {
                  title: 'Parameter',
                  align: 'center',
                  dataIndex: 'parameter_name',
                  key: 'parameter',
                  render: (data, record) => {
                    return data ? data : 'NA';
                  },
                },
                {
                  title: 'Min',
                  align: 'center',
                  dataIndex: 'min_value',
                  key: 'min_value',
                  render: (data) => {
                    return data !== 'NA' ? `${data}(${record?.parameter_name_unit}) ` : 'NA';
                  },
                },
                {
                  title: 'Max',
                  align: 'center',
                  dataIndex: 'max_value',
                  key: 'max_value',
                  render: (data) => {
                    return data !== 'NA' ? `${data}(${record?.parameter_name_unit}) ` : 'NA';
                  },
                },
              ]}
              data={record?.sampling || []}
              bordered
              style={{ width: '100%' }}
            />
          </Panel>
        )}

        {record?.machines && record?.machines?.length > 0 && (
          <Panel header="Machines" key="4">
            <DataTable
              height={null}
              pagination={false}
              columns={[
                {
                  title: 'Machine Name',
                  dataIndex: 'machine_name',
                  key: 'machine_name',
                },
              ]}
              data={record?.machines || []}
              bordered
              style={{ width: '100%' }}
            />
          </Panel>
        )}
      </Collapse>
    );
  };

  // collapse for operations





  // ISSUE lane: get_employee_list()/successGetEmployee removed. `employeeList` was written here
  // and never read anywhere on this page, so bp_get_employee_user was a dead request whose only
  // visible effect was a 403 (module "User Management") for every role that does not administer
  // users — the Planner among them. The employee directory correctly stays behind User Management;
  // if this page ever needs it, that permission question has to be answered rather than the call
  // restored.








  // Release approval (qa-head F5): approve and reject both open the sign modal; the decision goes to
  // /bp/release_approval together with esign {username, password, comment} — the backend checks the
  // role, SoD and verifies the password, and links the ESignatureRecord to the decision.
  const handleApprove = (record) => {
    setPendingApprovalBatch(record);
    setReleaseSignAction('approve');
    setShowESignatureModal(true);
  };

  const handleReject = (record) => {
    setPendingApprovalBatch(record);
    setReleaseSignAction('reject');
    setShowESignatureModal(true);
  };

  const submitReleaseDecision = async (esign) => {
    const record = pendingApprovalBatch;
    if (!record) return;
    setReleaseSigning(true);
    try {
      const res = await postAct('release_approval', {
        batch_number: record.batch_number,
        approval: releaseSignAction === 'approve',
        comment: esign.comment,
        esign,
      });
      setShowESignatureModal(false);
      setPendingApprovalBatch(null);
      toast.success(res?.message);
      reloadLists();
      setSummaryTick((n) => n + 1);
    } catch (err) {
      if (!showGateReasons(err, 'Issue approval refused')) toast.warning(actErrorMessage(err));
    }
    setReleaseSigning(false);
  };


  // the QA release (the release review's disposition the Status cell reads), or null when the batch is not released
  // const releaseOf = (record) => (record?.disposition?.code === 'Released' ? record.disposition : null);
  const completed_Batch_columns = [
    {
      title: selectedModule === 'prod' ? mbmrAlias : 'MBPR',
      dataIndex: 'recipe_name',
      key: 'recipe_name',
      align: 'center',
      width: 140,
      sorter: (a, b) => a?.recipe_name?.localeCompare(b?.recipe_name), // ✅ sorting
      render: (text, record) => (
        <Tooltip title={record?.process_list?.length ? `${text} — ${record.process_list.join(' → ')}` : text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    {
      title: selectedModule === 'prod' ? 'BMR' : 'BPR',
      dataIndex: 'batch_number',
      key: 'batch_number',
      align: 'center',
      width: 170,
      sorter: (a, b) => a?.batch_number?.localeCompare(b?.batch_number),
      // a back-dated KPI-history batch says so, instead of looking like a live batch with no data
      render: (text, record) => (
        <Tooltip title={record?.is_historical ? `${text} — back-dated record kept for trend history` : text} placement="top">
          <div className="truncate w-full">
            {text}
            {record?.is_historical ? (
              <Tag color="default" className="ml-1 text-xs">
                Historical
              </Tag>
            ) : null}
            {record?.deviation_count > 0 || record?.open_deviation_count > 0 ? (
              <Tag color="error" className="ml-1 text-xs">
                {(record?.deviation_count || 0) + (record?.open_deviation_count || 0)} dev
              </Tag>
            ) : null}
          </div>
        </Tooltip>
      ),
    },
    {
      title: 'Product',
      dataIndex: 'product_name',
      key: 'product_name',
      align: 'center',
      width: 140,
      sorter: (a, b) => (a?.product_name || '').localeCompare(b?.product_name || ''),
      render: (text, record) => (
        <Tooltip title={record?.product_code ? `${record.product_code} — ${text || ''}` : text} placement="top">
          <div className="truncate w-full">{text || '—'}</div>
        </Tooltip>
      ),
    },
    {
      title: selectedModule === 'prod' ? 'BMR Size' : 'BPR Size',
      dataIndex: 'batch_size',
      key: 'batch_size',
      align: 'center',
      width: 110,
      sorter: (a, b) => a?.batch_size - b?.batch_size, // ✅ numeric sort
      render: (text, record) => (
        <Tooltip title={`${text ?? ''} ${record?.batch_uom || ''}`.trim()} placement="top">
          <div className="truncate w-full">
            {text}
            {record?.batch_uom ? ` ${record.batch_uom}` : ''}
          </div>
        </Tooltip>
      ),
    },
    {
      title: 'Yield',
      dataIndex: 'yield_percent',
      key: 'yield_percent',
      align: 'center',
      width: 110,
      sorter: (a, b) => (a?.yield_percent || 0) - (b?.yield_percent || 0),
      render: (text, record) => (
        <Tooltip
          title={[
            record?.theoretical_output != null && `Theoretical ${record.theoretical_output} ${record.output_uom || ''}`,
            record?.actual_output != null && `Actual ${record.actual_output} ${record.output_uom || ''}`,
          ]
            .filter(Boolean)
            .join(' · ')}
          placement="top"
        >
          <div className="truncate w-full">
            {text != null ? `${text} %` : record?.theoretical_output != null ? `${record.theoretical_output} ${record.output_uom || ''}` : '—'}
          </div>
        </Tooltip>
      ),
    },
    {
      // EXR-W1 W1-10 (EXV-001): the server's status word. 2026-11-01 (owner) · one status here: QA's disposition word no
      // longer sits beside it (this tab lists completed batches; the release is read on Review & Release).
      title: 'Status',
      dataIndex: 'status_word',
      key: 'status_word',
      align: 'center',
      width: 140,
      sorter: (a, b) => (a?.status_word || '').localeCompare(b?.status_word || ''),
      render: (_, record) => <BatchStatusCell record={record} showDisposition={false} />,
    },
    // 2026-11-01 (owner) · Released by / Released on commented out for now: no batch has a QA release yet, so they
    // only showed dashes. Bring them back (with `releaseOf` above) once releases are in use.
    // {
    //   title: 'Released by',
    //   dataIndex: 'released_by',
    //   key: 'released_by',
    //   align: 'center',
    //   width: 140,
    //   sorter: (a, b) => (releaseOf(a)?.by || '').localeCompare(releaseOf(b)?.by || ''),
    //   render: (_, record) => {
    //     const by = releaseOf(record)?.by;
    //     return by ? (
    //       <Tooltip title={by} placement="top">
    //         <div className="truncate w-full">{by}</div>
    //       </Tooltip>
    //     ) : (
    //       '—'
    //     );
    //   },
    // },
    // {
    //   title: 'Released on',
    //   dataIndex: 'released_on',
    //   key: 'released_on',
    //   align: 'center',
    //   width: 126,
    //   sorter: (a, b) => sortTime(releaseOf(a)?.at) - sortTime(releaseOf(b)?.at),
    //   render: (_, record) => {
    //     const at = releaseOf(record)?.at;
    //     return at ? (
    //       <Tooltip title={formatDateTimeSeconds(at)} placement="top">
    //         <div className="truncate w-full">{formatDateTime(at)}</div>
    //       </Tooltip>
    //     ) : (
    //       '—'
    //     );
    //   },
    // },
    {
      title: 'Scheduled Time',
      dataIndex: 'batch_schedule_time',
      key: 'batch_schedule_time',
      width: 156,
      align: 'center',
      sorter: (a, b) => sortTime(a?.batch_schedule_time) - sortTime(b?.batch_schedule_time),
      render: (data) => (
        <Tooltip title={formatDateTimeSeconds(data)} placement="top">
          <div className="truncate w-full">{formatDateTime(data)}</div>
        </Tooltip>
      ),
    },
    {
      title: 'Start Time',
      dataIndex: 'batch_start_time',
      key: 'batch_start_time',
      width: 156,
      align: 'center',
      sorter: (a, b) => sortTime(a.batch_start_time) - sortTime(b.batch_start_time),
      render: (batch_start_time) => (
        <Tooltip title={formatDateTimeSeconds(batch_start_time)} placement="top">
          <div className="truncate w-full">{formatDateTime(batch_start_time)}</div>
        </Tooltip>
      ),
    },
    {
      title: 'Completion Time',
      dataIndex: 'batch_end_time',
      key: 'batch_end_time',
      width: 160,
      align: 'center',
      sorter: (a, b) => sortTime(a?.batch_end_time) - sortTime(b?.batch_end_time),
      render: (batch_end_time) => (
        <Tooltip title={formatDateTimeSeconds(batch_end_time)} placement="top">
          <div className="truncate w-full">{formatDateTime(batch_end_time)}</div>
        </Tooltip>
      ),
    },
    {
      title: 'Duration',
      dataIndex: 'duration',
      key: 'duration',
      width: 100,
      align: 'center',
      sorter: (a, b) => (a?.duration || 0) - (b?.duration || 0), // ✅ numeric sort
      render: (text) => (
        <Tooltip title={text} placement="top">
          <div className="truncate w-full">{text}</div>
        </Tooltip>
      ),
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   align: "center",
    //   render: (data, record, index) => {
    //     return (
    //       <Button
    //         onClick={() => {
    //           setShowGraph(true);
    //           setSelectedBatchForGraph(record.batch_number);
    //         }}
    //       >
    //         <AutoGraphIcon color="primary" />
    //       </Button>
    //     );
    //   },
    // },
    {
      // These are the batch's ISSUE approvals (they gate the start), not its release.
      title: 'Issue Approval',
      dataIndex: 'role_list',
      key: 'process_roles',
      width: 140,
      align: 'center',
      render: (processRoles) => (
        <div className="w-full">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div
              style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}
              className="flex-wrap"
            >
              {processRoles &&
                processRoles?.some((role) => matchesApprovalRole(role, 'PRODUCTION_MANAGER')) && (
                  <Tooltip
                    title={
                      processRoles?.find((role) => matchesApprovalRole(role, 'PRODUCTION_MANAGER'))
                        .approval_status === 'approve'
                        ? 'Approved'
                        : 'Approval Pending'
                    }
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checkedIcon={<CheckBoxIcon fontSize="small" />}
                          checked={
                            processRoles?.find((role) => matchesApprovalRole(role, 'PRODUCTION_MANAGER'))
                              .approval_status === 'approve'
                              ? true
                              : false
                          }
                        />
                      }
                      label={<span className="text-sm">Production</span>}
                    />
                  </Tooltip>
                )}
              {processRoles && processRoles?.some((role) => matchesApprovalRole(role, 'RD')) && (
                <Tooltip
                  title={
                    processRoles?.find((role) => matchesApprovalRole(role, 'RD')).approval_status ===
                    'approve'
                      ? 'Approved'
                      : 'Approval Pending'
                  }
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        checked={
                          processRoles?.find((role) => matchesApprovalRole(role, 'RD')).approval_status ===
                          'approve'
                            ? true
                            : false
                        }
                      />
                    }
                    label={<span className="text-sm">R&D</span>}
                  />
                </Tooltip>
              )}
              {processRoles && processRoles?.some((role) => matchesApprovalRole(role, 'QA')) && (
                <Tooltip
                  title={
                    processRoles?.find((role) => matchesApprovalRole(role, 'QA')).approval_status ===
                    'approve'
                      ? 'Approved'
                      : 'Approval Pending'
                  }
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        checked={
                          processRoles?.find((role) => matchesApprovalRole(role, 'QA')).approval_status ===
                          'approve'
                            ? true
                            : false
                        }
                      />
                    }
                    label={<span className="text-sm">QA</span>}
                  />
                </Tooltip>
              )}
            </div>
          </div>
        </div>
      ),
    },
    // ...get_view_function(),
    {
      // 2026-11-01 (owner) · the same icon buttons as the page's other tabs (.bmrd-actions).
      title: 'Actions',
      dataIndex: '',
      key: 'material_balance',
      width: 124,
      render: (_, record) => (
        <div className="bmrd-actions">
          <Tooltip title="View Report">
            <Button
              icon={<Icons.Eye size={16} />}
              aria-label={`View report of ${record?.batch_number}`}
              onClick={() => setReportBatch(record?.batch_number)}
            />
          </Tooltip>
          <Tooltip title="Material Balance">
            <Button
              icon={<Icons.FileText size={16} />}
              aria-label={`Material balance of ${record?.batch_number}`}
              onClick={() => setBalanceBatch(record?.batch_number)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];


  const add_schedule = (lot_batch_type) => (
    <Scheduling
      refresh={refresh}
      set_refresh={set_refresh}
      selectedButton={selectedButton}
      set_view_bom_data={set_view_bom_data}
      setIsBomVisible={setIsBomVisible}
      setMinMaxBatchSize={setMinMaxBatchSize}
      setBatchSize={setBatchSize}
      batch_type={lot_batch_type || batch_type}
      masterBatch={master_batch}
      selectedLots={selectedLots}
      setSelectedLots={setSelectedLots}
      onSuccess={() => set_show_add_schedule(false)}
    />
  );

  // The BMR Details lists (Ongoing, Completed, Issue approval, Rejected) read their own pages (BatchListTab); this
  // reads only the Separate Kitting tab.
  const get_all_batchDetails = async () => {
    if (tab_value !== '7') return;
    try {
      setSeparateQrLoading(true);
      await get_seperate_qr_details(
        {
          page_number: separateQrPage,
          recipe_type: recipeTypeFlag,
          ...(separateQrSearch && { search_item: separateQrSearch }),
        },
        (res) => {
          if (res?.data?.status === 'success') {
            setSeparateQrData(res.data.data || []);
            setSeparateQrTotal(res.data.obj_count || 0);
          }
          setSeparateQrLoading(false);
        }
      );
    } catch (error) {
      console.error('Error fetching data:', error);
      setSeparateQrLoading(false);
    }
  };

  // one parameter set for every list: page, module, recipe scope and the shared filters
  const listRequest = (pageNumber) =>
    listParams({ page: pageNumber, moduleType: selectedModule || 'prod', recipeType: recipeTypeFlag, filters: listFilters });
  /* eslint-disable react-hooks/exhaustive-deps -- each reader is rebuilt when the request it sends changes */
  const loadOngoing = useCallback((pg) => fetchOngoing(listRequest(pg)), [listFilters, selectedModule, recipeTypeFlag]);
  const loadCompleted = useCallback(
    (pg) =>
      fetchCompleted({ ...listRequest(pg), ...completedParams(completedFilters), ...(pg === 1 ? { filter_options: 1 } : {}) }).then((r) => {
        if (r.filterOptions) setCompletedOptions(r.filterOptions);
        return r;
      }),
    [listFilters, completedFilters, selectedModule, recipeTypeFlag]
  );
  const loadIssueApproval = useCallback((pg, scope) => fetchIssueApproval({ ...listRequest(pg), scope }), [listFilters, selectedModule, recipeTypeFlag]);
  const loadRejected = useCallback((pg) => fetchRejected(listRequest(pg)), [listFilters, selectedModule, recipeTypeFlag]);
  /* eslint-enable react-hooks/exhaustive-deps */
  const applyFilters = (next) => {
    setListFilters(next);
    reloadLists();
  };
  // the search sits on each table's own toolbar; MBMR and the schedule-date range are the page's header filters
  const listToolbar = (
    <BatchListFilters value={listFilters} onChange={applyFilters} moduleType={selectedModule || 'prod'} mbmrLabel={mbmrWord} showMbmr={false} showDates={false} />
  );
  const filterActiveCount = (listFilters.recipeId ? 1 : 0) + (listFilters.from && listFilters.to ? 1 : 0);
  const clearListFilters = () => applyFilters({ ...listFilters, recipeId: null, from: null, to: null });
  const applyCompletedFilters = (next) => {
    setCompletedFilters(next);
    reloadLists();
  };
  const completedFilterCount =
    filterActiveCount +
    (completedFilters.status ? 1 : 0) +
    (completedFilters.releasedBy ? 1 : 0) +
    (completedFilters.releasedFrom && completedFilters.releasedTo ? 1 : 0);
  const clearCompletedFilters = () => {
    setCompletedFilters({ status: null, releasedBy: null, releasedFrom: null, releasedTo: null });
    clearListFilters();
  };
  const funnelContent = (
    <div className="flex flex-col gap-2" style={{ minWidth: 260 }}>
      <BatchListFilters value={listFilters} onChange={applyFilters} moduleType={selectedModule || 'prod'} mbmrLabel={mbmrWord} showSearch={false} />
    </div>
  );
  const completedFunnelContent = (
    <div className="flex flex-col gap-2" style={{ minWidth: 260 }}>
      <BatchListFilters value={listFilters} onChange={applyFilters} moduleType={selectedModule || 'prod'} mbmrLabel={mbmrWord} showSearch={false} />
      <CompletedStatusFilters value={completedFilters} onChange={applyCompletedFilters} options={completedOptions} />
    </div>
  );
  const mbmrFunnelContent = (
    <div className="flex flex-col gap-2" style={{ minWidth: 260 }}>
      <BatchListFilters value={listFilters} onChange={applyFilters} moduleType={selectedModule || 'prod'} mbmrLabel={mbmrWord} showSearch={false} showDates={false} />
    </div>
  );
  const headerFilters = (
    <BatchListFilters value={listFilters} onChange={applyFilters} moduleType={selectedModule || 'prod'} mbmrLabel={mbmrWord} showSearch={false} />
  );
  const openTab = (key) => {
    set_page_number(1);
    set_dag_batch();
    setSelectedRowKeys([]);
    setReportView(false);
    set_tab_value(key);
  };


  const success_bp_get_batch_changes_details = (res) => {
    if (res?.data?.message !== 'Data Retrived Successfully') {
      toast?.success(res?.data.message);
    }
    set_modified_details(addKeysInFilterDataForCollapse(res?.data?.data || []));
  };


  useEffect(() => {
    try {
      const data = localStorage.getItem('user_access_data');
      if (data && data !== 'undefined' && data !== 'null') {
        set_user_access_data(JSON.parse(data));
      }
    } catch (error) {
      console.error('Error parsing user_access_data from localStorage:', error);
      localStorage.removeItem('user_access_data');
    }
    try {
      const settings = localStorage.getItem('app_setting');
      if (settings) setAppSetting(JSON.parse(settings) || []);
    } catch {
      /* ignore */
    }
  }, []);

  // Deep link: /batches?tab=<key>. Accepts the raw antd tab key or a stable
  // slug (the menu links /batches?tab=issue-approval) so the menu never has to
  // know the numeric keys.
  useEffect(() => {
    const tab = searchParams.get('tab') || (searchParams.get('status') === 'completed' ? 'completed' : null);
    if (!tab) return;
    if (deepLinkHandled.current === tab) return;
    deepLinkHandled.current = tab;
    set_tab_value(TAB_SLUGS[tab] || String(tab));
  }, [searchParams]);

  // Deep link: /batches?issue=1 — the "Issue Batch" menu item. Opens the Issue
  // Batch modal on the master-batch list instead of a separate page, then drops
  // the param so a reload or Back does not pop the modal again.
  // EXV-014: the modal opens over whatever tab is showing — it never switches to a tab of its own.
  useEffect(() => {
    if (!searchParams.get('issue')) return;
    set_master_batch_number('master');
    set_show_add_schedule(true);
    const next = new URLSearchParams(searchParams);
    next.delete('issue');
    setSearchParams(next, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  // Separate Kitting reads on its tab; `refresh` (an issued batch, a signed act) also re-reads the lists.
  useEffect(() => {
    get_all_batchDetails();
    setProductName('');
    set_is_schedule_lot(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedButton, tab_value, page_number, selectedModule]);

  const firstRefresh = useRef(true);
  useEffect(() => {
    if (firstRefresh.current) {
      firstRefresh.current = false;
      return;
    }
    reloadLists();
    setSummaryTick((n) => n + 1);
    get_all_batchDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  // EXV-017: the summary strip is read once per (module, recipe scope) and after an act — never on a page or tab
  // change. EXV-015: the module is always sent.
  useEffect(() => {
    let live = true;
    setSummaryError(null);
    fetchSummary({ module_type: selectedModule || 'prod', recipe_type: recipeTypeFlag })
      .then((d) => live && setSummaryData(d))
      .catch((e) => {
        if (!live) return;
        setSummaryData(undefined);
        setSummaryError(e || true);
      });
    return () => {
      live = false;
    };
  }, [selectedModule, recipeTypeFlag, summaryTick]);

  useEffect(() => {
    if (view_bom_data?.recipe_id) {
      get_all_bom_data(view_bom_data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view_bom_data]);

  const view_operation_function = (process, batch) => {
    set_selectedProcessId(process?.process_id);
    set_selectedProcessName(process?.process_number);
    // get_batch_details_by_process(process?.process_id, batch || current_batch);
    set_showSummary(true);
  };




  const timeline = (reportData, comStatus) => {
    return (
      <>
        <Grid item xs={12} lg={12}>
          <Descriptions
            bordered
            size="middle"
            column={1}
            className="w-full max-w-xl bg-white p-1  mt-2"
            labelStyle={{ fontWeight: 600 }}
          >
            <Descriptions.Item label={mbmrAlias}>{selected_recipe}</Descriptions.Item>
            <Descriptions.Item label="BMR">{current_batch}</Descriptions.Item>
          </Descriptions>
          <div className="font-bold mt-2 p-1 ">Workflow:</div>
        </Grid>
        <Grid
          item
          lg={12}
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '25px',
            maxHeight: '110vh',
            overflowY: 'scroll',
          }}
        >
          <Timeline
            items={reportData?.map((process, index_1) => ({
              //color: process?.operations?.length > 0 ? "green" : "red",
              color:
                process?.progress === 'Completed'
                  ? 'green'
                  : process?.progress === 'In Process'
                  ? 'orange'
                  : process?.progress === 'Pending' && 'red',
              // dot: (
              //   <ClockCircleOutlined
              //     style={{ color: "#FAAE2F", fontSize: "16px" }}
              //   />
              // ),

              children: !process?.parent_batch ? (
                <div
                  style={{
                    marginTop: '5px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '8px',
                      alignItems: 'center',
                    }}
                  >
                    <Typography>
                      <b>{'Process: '}</b>
                      {`${process?.process_number}`}
                    </Typography>

                    {showSummaryIndex !== index_1 ? (
                      <Tooltip title="View Operations">
                        <IconButton
                          onClick={() => {
                            set_dag_nodes([`${process?.op_id}`]);
                            view_operation_function(process);
                            set_showSummaryIndex(index_1);
                          }}
                        >
                          <EyeOutlined
                            color={
                              process?.progress === 'Completed'
                                ? 'success'
                                : process?.progress === 'In Process'
                                ? 'warning'
                                : process?.progress === 'Pending' && 'error'
                            }
                            style={{ fontSize: '20px' }}
                          />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Close">
                        <IconButton
                          onClick={() => {
                            set_showSummary(false);
                          }}
                        >
                          <CloseOutlined color="primary" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                </div>
              ) : (
                <div style={{ marginTop: '5px' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '8px',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      color: textColor,
                    }}
                    className="text-sm"
                  >
                    {/* Left: Lot Info */}
                    <div className="flex flex-col gap-1">
                      <div>
                        <b>Lot Number:</b> {process?.lot_number}
                      </div>
                      <div>
                        <b>BMR Number:</b> {process?.batch_number}
                      </div>
                      <div>
                        <b>Quantity:</b> {process?.quantity}
                      </div>
                      {/* <div>
                        <b>Details:</b>
                        <Tooltip title="View Details">
                          <EyeOutlined
                            onClick={async () => {
                              setReportView(false);
                              set_datashow_lot_number({
                                bmr: process?.lot_number,
                                status: process?.progress,
                              });
                              if (process?.progress === "Completed") {
                                await set_tab_value("3");
                              } else if (process?.progress === "In Process") {
                                await set_tab_value("2");
                              } else {
                                await set_tab_value("1");
                              }
                            }}
                            className="cursor-pointer text-blue-600 hover:text-blue-800 transition-colors duration-200"
                          />
                        </Tooltip>
                      </div> */}
                      <div>
                        <b>Status:</b>
                        <span
                          className={`px-2 py-1 rounded text-xs font-medium ${
                            process.progress === 'Completed'
                              ? 'bg-green-100 text-green-700'
                              : process?.progress === 'In Process'
                              ? 'bg-yellow-100 text-yellow-700'
                              : 'bg-red-100 text-red-700'
                          }`}
                        >
                          {process?.progress}
                        </span>
                      </div>
                    </div>

                    {/* Right: View or Close Button */}
                    {showSummaryIndex !== index_1 ? (
                      <Tooltip title="View Lot Details">
                        <IconButton
                          onClick={() => {
                            set_dag_nodes([`${process?.lot_number}`]); // if needed
                            view_operation_function(process);
                            set_showSummaryIndex(index_1);
                          }}
                        >
                          {/* <EyeOutlined
                            color={
                              lot_status === "Completed"
                                ? "success"
                                : lot_status === "In Process"
                                ? "warning"
                                : "error"
                            }
                            style={{ fontSize: "20px" }}
                          /> */}
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Close">
                        <IconButton onClick={() => set_showSummary(false)}>
                          <CloseOutlined color="primary" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                </div>
              ),
            }))}
          />
        </Grid>
      </>
    );
  };


  //############### handle Api's ################
  const getBatchReportData = async (batchNumber) => {
    try {
      await bp_get_batch_report_view(
        (res) => {
          if (res?.data?.status === 'success') {
            setReportData(res?.data?.data || []);
          } else {
            setReportData([]);
          }
        },
        { batch_number: batchNumber }
      );
    } catch (error) {
      console.error('Failed to fetch batch report:', error);
    } finally {
    }
  };


  const tabIconLabel = (icon, text) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      {icon}
      {text}
    </span>
  );

  return (
    <>
      <div
        className="p-2.5 pt-5"
        style={{
          width: '100%',
          backgroundColor: isDark ? defaultColors.palette.gray[900] : '#f9fafb',
        }}
      >
        <Card
          bordered={false}
          className="border border-gray-300 shadow-md"
          classNames={{ body: 'page-card-scroll' }}
          style={{ backgroundColor: cardBgColor, height: 'calc(100dvh - 120px)', display: 'flex', flexDirection: 'column' }}  /* 64px top bar + 20px/10px page padding + 26px footer = 120px */
          styles={{ body: { flex: 1, minHeight: 0, overflowY: 'auto', padding: '12px 16px' } }}
          title={
            <PageHeader
              compact
              icon={<Icons.ClipboardList size={22} />}
              title={t(`${recordWord} Details`)}
              description={`${selectedButton === 'production' ? 'Production records' : 'Trial records'} · this plant`}
              primary={{
                label: issueBatchLabel,
                icon: <PlusOutlined />,
                hidden: !canIssue,
                onClick: () => {
                  set_master_batch_number('master');
                  set_show_add_schedule(true);
                },
              }}
            />
          }
        >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    '& > *': {
                      m: 0,
                    },
                  }}
                >
                  {/* <ButtonGroup
                    type="default"
                    aria-label="View toggle"
                    size="small"
                  >
                    <Button
                      onClick={() => handleClick("test")}
                      style={buttonStyles(selectedButton === "test")}
                    >
                      Test
                    </Button>
                    <Button
                      onClick={() => handleClick("production")}
                      style={buttonStyles(selectedButton === "production")}
                    >
                      Production
                    </Button>
                  </ButtonGroup> */}
                </Box>

                {tab_value === '2' && dag_batch && (
                  <>
                    <Form.Item
                      label={<span style={{ fontWeight: 'bold', color: 'gray' }}>Product</span>}
                    >
                      <div
                        style={{
                          width: 'auto',
                          minWidth: '180px',
                          minHeight: '30px',
                          padding: '5px 10px',

                          borderRadius: '3px',
                          backgroundColor: '#F5F5F5',
                          fontSize: '14px',
                        }}
                      >
                        {productName}
                      </div>
                    </Form.Item>
                    <Form.Item
                      label={<span style={{ fontWeight: 'bold', color: 'gray' }}>Recipe</span>}
                    >
                      <div
                        style={{
                          width: 'auto',
                          minWidth: '180px',
                          minHeight: '30px',
                          padding: '5px 10px',

                          borderRadius: '3px',
                          backgroundColor: '#F5F5F5',
                          fontSize: '14px',
                        }}
                      >
                        {rowRecord?.recipe_name || ''}
                      </div>
                    </Form.Item>
                  </>
                )}
              </div>
            </div>
          {dag_batch ? (
            <div
              style={{
                border: '2px dashed #b3afaf',
                padding: '10px',
                borderRadius: '8px',
                marginBottom: 12,
              }}
            >
              <DAGFlowCopy data={dag_batch} set_flow_data={reset_flow} />
            </div>
          ) : null}
          <div className="bmrd" style={bmrdVars} data-testid="bmr-details">
                {!dag_batch && (
                  <BatchStateTiles
                    tiles={summaryData?.tiles}
                    // the read finished but carried no tiles: say so (with Retry) instead of an endless skeleton
                    error={summaryError || (summaryData && !summaryData.tiles ? true : null)}
                    onRetry={() => setSummaryTick((n) => n + 1)}
                    activeKey={null}
                    onOpen={(tile) => {
                      const link = new URL(tile.link || '/batches', window.location.origin);
                      const slug = link.searchParams.get('tab') || (link.searchParams.get('status') === 'completed' ? 'completed' : null);
                      if (slug && TAB_SLUGS[slug]) openTab(TAB_SLUGS[slug]);
                      else if (link.pathname !== '/batches') navigate(`${link.pathname}${link.search}`);
                    }}
                  />
                )}
              <Tabs
                activeKey={tab_value}
                size="large"
                tabBarStyle={{ backgroundColor: isDark ? defaultColors.palette.gray[700] : '#f9f9f9', borderRadius: '8px', padding: '2px 8px' }}
                onChange={openTab}
                items={[
                  {
                    key: '9',
                    label: tabIconLabel(<Icons.Activity size={16} />, 'Ongoing'),
                    children: (
                      <BatchListTab
                        testId="bmrd-ongoing"
                        what={`the ongoing ${recordWord}s`}
                        emptyMessage={`No ongoing ${recordWord}s found`}
                        reloadKey={`${listReload}|${selectedModule}|${recipeTypeFlag}`}
                        load={loadOngoing}
                        toolbar={listToolbar}
                        filterContent={funnelContent}
                        filterActiveCount={filterActiveCount}
                        onFilterClear={clearListFilters}
                        columns={ongoingColumns({
                          recordWord,
                          actions: {
                            canTerminate,
                            onViewRecord: (r) => navigate(`/batch-process-details/${r.batch_number}`),
                            onViewWorkflow: (r) => navigate('/batch-workflow', { state: { batch_number: r.batch_number, from: 'execution' } }),
                            onTerminate: (r) => setTerminateRecord(r),
                          },
                        })}
                      />
                    ),
                  },
                  {
                    key: '8',
                    label: tabIconLabel(<Icons.UserCheck size={16} />, 'Issue approval'),
                    children: (
                      <IssueApprovalTab
                        reloadKey={`${listReload}|${selectedModule}|${recipeTypeFlag}`}
                        load={loadIssueApproval}
                        toolbar={listToolbar}
                        filterContent={funnelContent}
                        filterActiveCount={filterActiveCount}
                        onFilterClear={clearListFilters}
                        columnsProps={{
                          recordWord,
                          mbmrLabel: mbmrWord,
                          onApprove: handleApprove,
                          onReject: handleReject,
                          canDecide: canDecideIssue,
                          onViewMbmr: (r) =>
                            setMbmrModal({ open: true, recipeId: r.recipe_id, title: r.recipe_name || `${mbmrWord} details` }),
                        }}
                      />
                    ),
                  },
                  // W1-9 (EXV-004): the Completed and Rejected lists are "BMR Details" reads on the server; the
                  // "Completed BMR" key no endpoint enforces no longer hides them.
                  ...(accessControlUtils('Batches')?.read_access
                    ? [
                        {
                          key: '3',
                          label: tabIconLabel(<Icons.CheckCheck size={16} />, 'Completed'),
                          children: (
                            <>
                              <BatchListTab
                                testId="bmrd-completed"
                                what={`the completed ${recordWord}s`}
                                emptyMessage={`No completed ${recordWord}s found`}
                                reloadKey={`${listReload}|${selectedModule}|${recipeTypeFlag}`}
                                load={loadCompleted}
                                toolbar={listToolbar}
                                filterContent={completedFunnelContent}
                                filterActiveCount={completedFilterCount}
                                onFilterClear={clearCompletedFilters}
                                columns={completed_Batch_columns}
                                tableProps={{
                                  rowSelection: {
                                    type: 'checkbox',
                                    columnTitle: 'Flow',
                                    columnWidth: 64,
                                    onChange: (keys, rows) => {
                                      set_dag_batch();
                                      setTimeout(() => {
                                        set_dag_batch(rows[rows.length - 1]);
                                        setSelectedRowKeys([keys[keys.length - 1]]);
                                      }, 1);
                                    },
                                    selectedRowKeys,
                                    hideSelectAll: true,
                                  },
                                }}
                              />
                              <BatchReportModal batchNumber={reportBatch} onClose={() => setReportBatch(null)} />
                              <MaterialBalanceModal batchNumber={balanceBatch} onClose={() => setBalanceBatch(null)} />
                            </>
                          ),
                        },
                        {
                          key: 'rejected',
                          label: tabIconLabel(<Icons.XCircle size={16} />, 'Rejected'),
                          children: (
                            <BatchListTab
                              testId="bmrd-rejected"
                              what={`the rejected ${recordWord}s`}
                              emptyMessage={`No rejected ${recordWord}s found`}
                              reloadKey={`${listReload}|${selectedModule}|${recipeTypeFlag}`}
                              load={loadRejected}
                              toolbar={listToolbar}
                              filterContent={funnelContent}
                              filterActiveCount={filterActiveCount}
                              onFilterClear={clearListFilters}
                              columns={rejectedColumns({
                                recordWord,
                                onViewRecord: (r) => navigate(`/batch-process-details/${r.batch_number}`),
                              })}
                            />
                          ),
                        },
                      ]
                    : []),
                  // Modified Batches tab — commented out for now, re-enable by
                  // uncommenting this block.
                  /* ...(accessControlUtils('Batches')?.read_access &&
                  accessControlUtils('Batches')?.read_access &&
                  selectedModule === 'prod'
                    ? [
                        {
                          key: '4',
                          label: 'Modified Batches',
                          children: (
                            <Row gutter={[8, 8]} style={{ width: '100%' }}>
                              <Col span={24}>
                                <div
                                  style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
                                >
                                  <div
                                    className="space-y-2 rounded-lg p-5 hover:shadow-lg shadow-md transition-all duration-300"
                                    style={{
                                      border: `1px solid ${borderColor}`,
                                      backgroundColor: sectionBgColor,
                                    }}
                                  >
                                    <div className="flex align-center justify-end">
                                      <TableColumnConfig menu={columnConfigMenu} />
                                    </div>
                                    <DataTable
                                      columnConfig={false}
                                      pagination={false}
                                      bordered
                                      loading={loading}
                                      columns={modified_Batch_columns}
                                      data={modifiedData}
                                      height="calc(100vh - 600px)"
                                      tableLayout="fixed"
                                      locale={{
                                        emptyText: (
                                          <Empty description="No modified batches found" />
                                        ),
                                      }}
                                    />
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'end',
                                      }}
                                    >
                                      <Pagination
                                        total={total}
                                        showTotal={(total) => `Total ${total} BMR's`}
                                        pageSize={10}
                                        current={page_number}
                                        showSizeChanger={false}
                                        onChange={(value) => {
                                          set_page_number(value);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          ),
                        },
                      ]
                    : []), */
                  ...(accessControlUtils('Batches')?.read_access &&
                  selectedModule === 'prod'
                    ? [
                        {
                          key: '5',
                          label: tabIconLabel(<Icons.Package size={16} />, 'Completed Kittings'),
                          children: (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                              <div style={{ overflow: 'visible' }}>
                                <CompletedKitting
                                  searchvalue={listFilters.search}
                                  selectedRecipe={listFilters.recipeId || ''}
                                  refresh={refresh}
                                  onColumnMenu={setKittingColumnMenu}
                                  filterContent={mbmrFunnelContent}
                                  filterActiveCount={listFilters.recipeId ? 1 : 0}
                                  onFilterClear={() => applyFilters({ ...listFilters, recipeId: null })}
                                />
                              </div>
                            </div>
                          ),
                        },
                      ]
                    : []),
                  // Master & Lot moved to Planner menu (/master-lot)
                  // ...(selectedModule === 'prod' && masterLotVisible
                  //   ? [
                  //       {
                  //         key: '6',
                  //         label: tabIconLabel(<Icons.Layers size={16} />, 'Master & Lot'),
                  //         children: <ProductionScheduler initialDemandId={deepLinkDemandId} />,
                  //       },
                  //     ]
                  //   : []),

                  ...(selectedModule === 'prod'
                    ? [
                        {
                          key: '7',
                          label: tabIconLabel(<Icons.QrCode size={16} />, 'Separate Kitting'),
                          children: (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                              <div style={{ overflow: 'visible' }}>
                                <DataTable
                                  tableKey="bmrdSeparateKittingTable"
                                  columnConfig
                                  filterPanel
                                  showCount={false}
                                  toolbarExtra={
                                <div className="flex gap-2">
                                  <Input
                                    placeholder="Search material, lot, QR no., batch..."
                                    prefix={<SearchOutlined />}
                                    value={separateQrSearch}
                                    allowClear
                                    style={{ width: 280 }}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      setSeparateQrSearch(val);
                                      if (!val) {
                                        setSeparateQrPage(1);
                                        setSeparateQrLoading(true);
                                        get_seperate_qr_details(
                                          { page_number: 1, recipe_type: recipeTypeFlag },
                                          (res) => {
                                            if (res?.data?.status === 'success') {
                                              setSeparateQrData(res.data.data || []);
                                              setSeparateQrTotal(res.data.obj_count || 0);
                                              setSeparateQrMaxPage(res.data.max_page_number || 1);
                                            }
                                            setSeparateQrLoading(false);
                                          }
                                        );
                                      }
                                    }}
                                    onPressEnter={() => {
                                      setSeparateQrPage(1);
                                      setSeparateQrLoading(true);
                                      get_seperate_qr_details(
                                        {
                                          page_number: 1,
                                          recipe_type: recipeTypeFlag,
                                          ...(separateQrSearch && {
                                            search_item: separateQrSearch,
                                          }),
                                        },
                                        (res) => {
                                          if (res?.data?.status === 'success') {
                                            setSeparateQrData(res.data.data || []);
                                            setSeparateQrTotal(res.data.obj_count || 0);
                                            setSeparateQrMaxPage(res.data.max_page_number || 1);
                                          }
                                          setSeparateQrLoading(false);
                                        }
                                      );
                                    }}
                                  />
                                  <Button
                                    type="primary"
                                    icon={<SearchOutlined />}
                                    style={{
                                      backgroundColor: defaultColors.primary,
                                      borderColor: defaultColors.primary,
                                    }}
                                    onClick={() => {
                                      setSeparateQrPage(1);
                                      setSeparateQrLoading(true);
                                      get_seperate_qr_details(
                                        {
                                          page_number: 1,
                                          recipe_type: recipeTypeFlag,
                                          ...(separateQrSearch && {
                                            search_item: separateQrSearch,
                                          }),
                                        },
                                        (res) => {
                                          if (res?.data?.status === 'success') {
                                            setSeparateQrData(res.data.data || []);
                                            setSeparateQrTotal(res.data.obj_count || 0);
                                            setSeparateQrMaxPage(res.data.max_page_number || 1);
                                          }
                                          setSeparateQrLoading(false);
                                        }
                                      );
                                    }}
                                  >
                                    Search
                                  </Button>
                                  <Button
                                    icon={<ReloadOutlined />}
                                    onClick={() => {
                                      setSeparateQrPage(1);
                                      setSeparateQrSearch('');
                                      setSeparateQrLoading(true);
                                      get_seperate_qr_details(
                                        { page_number: 1, recipe_type: recipeTypeFlag },
                                        (res) => {
                                          if (res?.data?.status === 'success') {
                                            setSeparateQrData(res.data.data || []);
                                            setSeparateQrTotal(res.data.obj_count || 0);
                                            setSeparateQrMaxPage(res.data.max_page_number || 1);
                                          }
                                          setSeparateQrLoading(false);
                                        }
                                      );
                                    }}
                                  >
                                    Refresh
                                  </Button>
                                </div>
                                  }
                                  pagination={false}
                                  bordered
                                  loading={separateQrLoading}
                                  tableLayout="fixed"
                                  scrollX="max-content"
                                  height="calc(100vh - 560px)"
                                  locale={{
                                    emptyText: (
                                      <Empty description="No separate kitting records found" />
                                    ),
                                  }}
                                  data={separateQrData.map((r) => ({ ...r, key: r.id }))}
                                  columns={[
                                    {
                                      title: 'Material Name',
                                      dataIndex: 'material_name',
                                      key: 'material_name',
                                      width: 160,
                                    },
                                    {
                                      title: 'Material Unique ID',
                                      dataIndex: 'material_unique_id',
                                      key: 'material_unique_id',
                                      width: 150,
                                    },
                                    {
                                      title: 'Lot No.',
                                      dataIndex: 'lot_number',
                                      key: 'lot_number',
                                      width: 110,
                                    },
                                    {
                                      title: 'Batch No.',
                                      dataIndex: 'batch_number',
                                      key: 'batch_number',
                                      width: 110,
                                    },
                                    {
                                      title: 'QR Number',
                                      dataIndex: 'qr_number',
                                      key: 'qr_number',
                                      width: 130,
                                    },
                                    {
                                      title: 'QR Type',
                                      dataIndex: 'qr_type',
                                      key: 'qr_type',
                                      width: 110,
                                      align: 'center',
                                      render: (val) => (
                                        <Tag
                                          color={val === 'M' ? 'blue' : 'green'}
                                          style={{ fontWeight: 600 }}
                                        >
                                          {val === 'M'
                                            ? 'Mother'
                                            : val === 'C'
                                            ? 'Child'
                                            : val || '-'}
                                        </Tag>
                                      ),
                                    },
                                    {
                                      title: 'Quantity',
                                      dataIndex: 'quantity',
                                      key: 'quantity',
                                      width: 90,
                                      align: 'center',
                                    },
                                    {
                                      title: 'Pack 1',
                                      dataIndex: 'pack_1',
                                      key: 'pack_1',
                                      width: 90,
                                    },
                                    {
                                      title: 'Pack 2',
                                      dataIndex: 'pack_2',
                                      key: 'pack_2',
                                      width: 90,
                                    },
                                    {
                                      title: 'Gross Wt.',
                                      dataIndex: 'gross_weight',
                                      key: 'gross_weight',
                                      width: 100,
                                      align: 'center',
                                    },
                                    {
                                      title: 'Net Wt.',
                                      dataIndex: 'net_weight',
                                      key: 'net_weight',
                                      width: 100,
                                      align: 'center',
                                    },
                                    {
                                      title: 'Tare Wt.',
                                      dataIndex: 'tare_weight',
                                      key: 'tare_weight',
                                      width: 100,
                                      align: 'center',
                                    },
                                    {
                                      title: 'Mfg Date',
                                      dataIndex: 'open_date',
                                      key: 'open_date',
                                      width: 110,
                                      align: 'center',
                                    },
                                    {
                                      title: 'Expiry Date',
                                      dataIndex: 'expiry_date',
                                      key: 'expiry_date',
                                      width: 110,
                                      align: 'center',
                                    },
                                    {
                                      title: 'Created On',
                                      dataIndex: 'created_on',
                                      key: 'created_on',
                                      width: 150,
                                      align: 'center',
                                    },
                                    {
                                      title: 'Actions',
                                      key: 'action',
                                      fixed: 'right',
                                      width: 76,
                                      render: (_, record) => (
                                        <div className="bmrd-actions">
                                          <Tooltip title="View & Reprint QR">
                                            <Button
                                              icon={<PrinterOutlined />}
                                              aria-label={`View and reprint QR of ${record?.batch_number || 'this record'}`}
                                              onClick={() => {
                                                setPreviewRecord(record);
                                                setPreviewModalVisible(true);
                                              }}
                                            />
                                          </Tooltip>
                                        </div>
                                      ),
                                    },
                                  ]}
                                />
                              </div>
                              <div className="flex justify-end mt-3">
                                <Pagination
                                  total={separateQrTotal}
                                  showTotal={(t) => `Total ${t} records`}
                                  pageSize={15}
                                  current={separateQrPage}
                                  showSizeChanger={false}
                                  onChange={(val) => {
                                    setSeparateQrPage(val);
                                    setSeparateQrLoading(true);
                                    get_seperate_qr_details(
                                      {
                                        page_number: val,
                                        recipe_type: recipeTypeFlag,
                                        ...(separateQrSearch && { search_item: separateQrSearch }),
                                      },
                                      (res) => {
                                        if (res?.data?.status === 'success') {
                                          setSeparateQrData(res.data.data || []);
                                          setSeparateQrTotal(res.data.obj_count || 0);
                                          setSeparateQrMaxPage(res.data.max_page_number || 1);
                                        }
                                        setSeparateQrLoading(false);
                                      }
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          ),
                        },
                      ]
                    : []),
                ]?.filter(Boolean)}
              />
          </div>
        </Card>
        {/* Separate Kitting — QR Preview & Reprint Modal */}
        <Modal
          open={previewModalVisible}
          title={
            <div className="flex items-center gap-2">
              <PrinterOutlined />
              <span>QR Label Preview</span>
              {previewRecord && (
                <Tag
                  color={previewRecord.qr_type === 'M' ? 'blue' : 'green'}
                  style={{ fontSize: 14, fontWeight: 700, padding: '2px 10px', marginLeft: 8 }}
                >
                  {previewRecord.qr_type === 'M' ? 'Master (M)' : 'Child (C)'}
                </Tag>
              )}
            </div>
          }
          width={680}
          onCancel={() => {
            setPreviewModalVisible(false);
            setPreviewRecord(null);
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                setPreviewModalVisible(false);
                setPreviewRecord(null);
              }}
            >
              Cancel
            </Button>,
            <Button
              key="print"
              type="primary"
              icon={<PrinterOutlined />}
              loading={reprintLoading === previewRecord?.id}
              style={{ backgroundColor: defaultColors.primary, borderColor: defaultColors.primary }}
              onClick={() => {
                if (!previewRecord) return;
                setReprintLoading(previewRecord.id);
                reprint_seperate_qr({ qr_id: previewRecord.id }, (res) => {
                  if (res?.data?.status === 'success') {
                    toast.success('QR Reprinted Successfully');
                    setPreviewModalVisible(false);
                    setPreviewRecord(null);
                  } else {
                    toast.error(res?.data?.message || 'Reprint failed');
                  }
                  setReprintLoading(null);
                });
              }}
            >
              Confirm & Print
            </Button>,
          ]}
          zIndex={1500}
        >
          {previewRecord && (
            <div>
              <div className="flex gap-6 items-start">
                <div className="flex flex-col items-center gap-2" style={{ minWidth: 150 }}>
                  <AntQRCode
                    value={`${previewRecord.material_unique_id}-${previewRecord.batch_number}-${previewRecord.quantity}-${previewRecord.pack_1}/${previewRecord.pack_2}-R-${previewRecord.qr_number}-${previewRecord.ingredent_material_id}-${previewRecord.lot_number}-${previewRecord.open_date}-${previewRecord.expiry_date}-${previewRecord.quantity}`}
                    size={140}
                    style={{ border: '1px solid #d9d9d9', borderRadius: 6 }}
                  />
                  <span
                    style={{
                      fontSize: 11,
                      color: '#888',
                      textAlign: 'center',
                      wordBreak: 'break-all',
                      maxWidth: 150,
                    }}
                  >
                    {previewRecord.qr_number}
                  </span>
                </div>
                <div style={{ flex: 1 }}>
                  <Descriptions column={2} size="small" bordered>
                    <Descriptions.Item label="Material Name" span={2}>
                      {previewRecord.material_name || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Material Unique ID">
                      {previewRecord.material_unique_id || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Lot No.">
                      {previewRecord.lot_number || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Batch No.">
                      {previewRecord.batch_number || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Quantity">
                      {previewRecord.quantity || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Pack 1">
                      {previewRecord.pack_1 || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Pack 2">
                      {previewRecord.pack_2 || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Mfg Date">
                      {previewRecord.open_date || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Expiry Date">
                      {previewRecord.expiry_date || '-'}
                    </Descriptions.Item>
                    {previewRecord.qr_type === 'C' && (
                      <>
                        <Descriptions.Item label="Gross Wt.">
                          {previewRecord.gross_weight || '-'}
                        </Descriptions.Item>
                        <Descriptions.Item label="Net Wt.">
                          {previewRecord.net_weight || '-'}
                        </Descriptions.Item>
                        <Descriptions.Item label="Tare Wt." span={2}>
                          {previewRecord.tare_weight || '-'}
                        </Descriptions.Item>
                      </>
                    )}
                  </Descriptions>
                </div>
              </div>
              <Divider style={{ margin: '12px 0' }} />
              <div style={{ fontSize: 12, color: '#888' }}>
                Created On: {previewRecord.created_on || '-'}
              </div>
            </div>
          )}
        </Modal>
        <Modal
          open={isVisible}
          title={'Modified Operation'}
          width={1200}
          onCancel={handleCancel}
          footer={null}
          zIndex="1500"
        >
          <div className="mt-4">
            <DataTable
              height={null}
              data={modified_details}
              columns={processColumns}
              pagination={false}
              showHeader={true}
              expandable={{
                expandedRowRender: expandedRowRenderCols,
              }}
            />
          </div>
        </Modal>
        <OperationsSkeleton
          show={showSummary}
          report={processOperations || []}
          setShow={set_showSummary}
          scheduletime={scheduleTimeStatus}
          selected_recipe={selected_recipe}
          tab={tab_value}
          setAssignStatus={setAssignStatus}
          assignStatus={assignStatus}
          selectedProcessId={selectedProcessId}
          current_batch={current_batch}
          set_selectedProcessId={set_selectedProcessId}
          selectedProcessName={selectedProcessName}
          set_showSummaryIndex={set_showSummaryIndex}
          bulk_assign_list={bulk_assign_list}
        />
        <Modal
          // 2026-10-16 (owner) · the plain BOM — no SAP import and no AR columns here: loading the BOM from
          // SAP (AR, assay, quantity to take) is its own step before the batch is issued (SapBomGate).
          title={`Bill of Materials${view_bom_data?.batch_number ? ` — ${view_bom_data.batch_number}` : ''}`}
          open={isBomVisible}
          onCancel={handleCancel}
          footer={null}
          width={800}
          zIndex={2000}
        >
          <DataTable
            height={null}
            data={bomList}
            columns={[
              {
                title: 'Material Name',
                dataIndex: 'material_name',
                key: 'title',
                sorter: (a, b) => a?.material_name?.localeCompare(b?.material_name), // ✅ sorting
                filteredValue: [searchvalue],
                onFilter: (value, record) => {
                  return String(record.material_name).toLowerCase().includes(value.toLowerCase());
                },
                align: 'center',
              },
              {
                title: 'Quantity',
                dataIndex: 'quantity',
                key: 'quantity',
                align: 'center',
                sorter: (a, b) => a?.quantity - b?.quantity, // ✅ numeric sorting
                render: (data, record, index) => {
                  // 2026-10-15 · the server's BOM calculated for this batch size (the MBMR's MBOM ×
                  // batch size ÷ its batch size) — the figure the batch is issued and weighed against.
                  if (record?.batch_quantity != null) {
                    return `${fmtQty(record.batch_quantity)} ${record?.unit || ''}`;
                  }
                  if (batchSize && batchSize !== '0') {
                    const calculatedValue = appSetting?.find(
                      (app) => app?.module === 'Material Cost Calculation'
                    )?.value;
                    if (calculatedValue) {
                      const op = Number(evaluateFormula(
                        calculatedValue,
                        record?.quantity,
                        minMaxBatchSize?.actual,
                        batchSize
                      ));
                      // A formula the screen cannot evaluate ("standard") answers a sentence, not a
                      // number — fall through to the plain arithmetic instead of crashing the table.
                      if (Number.isFinite(op)) return `${op.toFixed(2)} ${record?.unit || ''}`;
                    }
                  }
                  return `${fmtQty(parseFloat(data) * parseFloat(batchSize))} ${record?.unit || ''}`;
                },
              },
              {
                title: 'Type',
                dataIndex: 'material_type',
                key: 'type',
                align: 'center',
              },
              // 2026-10-15 (owner) · no Lots column on View BOM — lots are not picked at issue.
            ]}
            pagination={{ pageSize: 5 }}
            bordered
          />
        </Modal>

        {/* ===== Lot Picker Modal ===== */}
        <Modal
          title={`Select Lots — ${lotPicker.material?.material_name || ''}`}
          open={lotPicker.open}
          onCancel={closeLotPicker}
          width={900}
          zIndex={2100}
          okText="Confirm"
          onOk={confirmLotPicker}
          okButtonProps={{ disabled: pickerTotal < lotPicker.required }}
          styles={{ body: { maxHeight: '70vh', overflowY: 'auto', paddingRight: 12 } }}
        >
          <div style={{ marginBottom: 12, display: 'flex', gap: 16, alignItems: 'center' }}>
            <Tag color="blue">
              Required: {lotPicker.required} {lotPicker.material?.unit || ''}
            </Tag>
            <Tag color={pickerTotal >= lotPicker.required ? 'green' : 'orange'}>
              Selected: {pickerTotal} {lotPicker.material?.unit || ''}
            </Tag>
            {pickerTotal < lotPicker.required && (
              <span style={{ color: '#c00', fontSize: 12 }}>
                Short by {lotPicker.required - pickerTotal} — add more lots
              </span>
            )}
          </div>
          <DataTable
            height={null}
            data={availableLots}
            rowKey="lot_id"
            size="small"
            pagination={{ pageSize: 8 }}
            expandable={{
              expandedRowKeys: availableLots
                .filter((l) => pickerSelection[l.lot_id] !== undefined)
                .map((l) => l.lot_id),
              showExpandColumn: false,
              expandedRowRender: (lot) => {
                // Quality parameters now come per-lot from the API (read-only display).
                // Fall back to the material-level parameters list if the per-lot data is absent.
                const lotParams = Array.isArray(lot.quality_parameters)
                  ? lot.quality_parameters
                  : [];
                const params = lotParams.length
                  ? lotParams
                  : lotPicker.material?.quality_parameters || [];
                if (!params.length) {
                  return (
                    <div
                      style={{
                        padding: '4px 0',
                        fontSize: 12,
                        color: '#9ca3af',
                        fontStyle: 'italic',
                      }}
                    >
                      No quality parameters configured for this lot.
                    </div>
                  );
                }
                return (
                  <div
                    style={{
                      padding: '12px 16px',
                      background: '#eef2ff',
                      border: '1px solid #a5b4fc',
                      borderRadius: 6,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: '#3730a3',
                        marginBottom: 10,
                      }}
                    >
                      Quality Parameters — Lot {lot.lot_number}
                    </div>
                    <DataTable
                      height={null}
                      data={params}
                      rowKey={(r) => r.parameter_id ?? r.id ?? r.name}
                      size="small"
                      pagination={false}
                      bordered
                      columns={[
                        {
                          title: 'Parameter',
                          dataIndex: 'name',
                          key: 'name',
                          width: '40%',
                          render: (name) => (
                            <span style={{ fontWeight: 600, color: '#1f2937' }}>{name || '-'}</span>
                          ),
                        },
                        {
                          title: 'Unit',
                          dataIndex: 'unit',
                          key: 'unit',
                          width: '15%',
                          render: (u) => u || '-',
                        },
                        {
                          title: 'Data Type',
                          dataIndex: 'data_type',
                          key: 'data_type',
                          width: '15%',
                          render: (dt) => <Tag color="geekblue">{dt || 'String'}</Tag>,
                        },
                        {
                          title: 'Value',
                          key: 'value',
                          width: '30%',
                          render: (_, p) => {
                            const val = p.value;
                            if (val === undefined || val === null || val === '') {
                              return <span style={{ color: '#9ca3af' }}>—</span>;
                            }
                            if ((p.data_type || '').toLowerCase() === 'boolean') {
                              return (
                                <Tag color={val ? 'green' : 'default'}>{val ? 'Yes' : 'No'}</Tag>
                              );
                            }
                            return <span>{String(val)}</span>;
                          },
                        },
                      ]}
                    />
                  </div>
                );
              },
            }}
            columns={[
              {
                title: '',
                key: 'select',
                width: 50,
                render: (_, lot) => (
                  <AntCheckbox
                    checked={pickerSelection[lot.lot_id] !== undefined}
                    onChange={(e) => togglePickerLot(lot, e.target.checked)}
                  />
                ),
              },
              { title: 'Batch #', dataIndex: 'batch_number', key: 'batch_number' },
              { title: 'Lot #', dataIndex: 'lot_number', key: 'lot_number' },
              {
                title: 'Available',
                dataIndex: 'quantity_available',
                key: 'quantity_available',
                align: 'right',
                render: (v) => `${v} ${lotPicker.material?.unit || ''}`,
              },
              {
                title: 'Expiry',
                dataIndex: 'expiry_date',
                key: 'expiry_date',
                render: (d) => formatDisplayDate(d, '-'),
              },
              {
                title: 'Consume Qty',
                key: 'consume',
                width: 140,
                render: (_, lot) => {
                  const checked = pickerSelection[lot.lot_id] !== undefined;
                  return (
                    <InputNumber
                      size="small"
                      min={0}
                      max={lot.quantity_available}
                      disabled={!checked}
                      value={pickerSelection[lot.lot_id]}
                      onChange={(val) => updatePickerLotQty(lot.lot_id, val)}
                      style={{ width: '100%' }}
                    />
                  );
                },
              },
            ]}
            locale={{ emptyText: 'No available lots for this material' }}
          />
        </Modal>
      </div>
      <Modal
        width={1200}
        title="Graph"
        open={showGraph}
        onCancel={() => setShowGraph(false)}
        footer={null}
        zIndex={1500}
      >
        <Graph batch_number={selectedBatchForGraph} />
      </Modal>
      <Modal
        width={1200}
        title="Issue Lot"
        zIndex={1500}
        open={is_schedule_lot}
        onCancel={() => set_is_schedule_lot(false)}
        footer={null}
        destroyOnHidden
      >
        {add_schedule('lot')}
        {/* {scheduleLotForm()} */}
      </Modal>
      <Base64Viewer
        batch_number={selectedBatchNumber}
        open={workflowReportView}
        onClose={() => setworkflowReportView(false)}
      />
      <TerminateBatchModal
        record={terminateRecord}
        onClose={() => setTerminateRecord(null)}
        onDone={(res) => {
          toast.success(res?.message || 'Batch terminated');
          setTerminateRecord(null);
          reloadLists();
          setSummaryTick((n) => n + 1);
        }}
      />
      <ApprovalSignModal
        open={showESignatureModal}
        action={releaseSignAction}
        busy={releaseSigning}
        title={`${releaseSignAction === 'reject' ? 'Reject' : 'Approve'} issue of ${pendingApprovalBatch?.batch_number || ''} — e-signature`}
        meaning={`${releaseSignAction === 'reject' ? 'Rejecting cancels the issue of' : 'Issue approval for'} ${pendingApprovalBatch?.batch_number || ''} · ${pendingApprovalBatch?.recipe_name || ''}`}
        requireReason={releaseSignAction === 'reject'}
        reasonLabel={releaseSignAction === 'reject' ? 'Reason for rejection' : 'Comment'}
        onCancel={() => {
          setShowESignatureModal(false);
          setPendingApprovalBatch(null);
        }}
        onSubmit={submitReleaseDecision}
      />

      {/* Issue Batch modal — creates/schedules a new batch from an approved
          MBMR/MBPR. This is NOT the QA release of a finished batch (that lives
          on /batch-approval). */}
      <PageModal
        open={show_add_schedule}
        onCancel={() => set_show_add_schedule(false)}
        icon={<Icons.ClipboardList size={22} />}
        title={issueBatchLabel}
        description={`Create a batch from an approved ${mbmrWord}`}
        width={1140}
        destroyOnHidden
      >
        {add_schedule()}
      </PageModal>

      {/* MBMR Detail Modal */}
      <MBMRDetailsModal
        open={mbmrModal.open}
        recipeId={mbmrModal.recipeId}
        title={mbmrModal.title}
        onClose={() => setMbmrModal({ open: false, recipeId: null, title: '' })}
      />
    </>
  );
}

export default ScheduledBatches;
